import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("Credits/api/GeneralAccountQuery").then(r => {
        commit("setList", r.data.data);
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("Credits/api/GeneralAccounts", model).then(() => {
    
      });
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Credits/api/GeneralAccounts",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          dispatch("fetch");
        });
    },
    update({ commit, dispatch }, model) {
      return ajax.put("Credits/api/GeneralAccounts", model).then(() => {
        dispatch("fetch");
      });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
